export default {
    teamProfile: null,

    isFinale: false,
}